import React, { Fragment } from 'react';
import { Box, Skeleton } from '@mui/material';
import { Alert, Table } from 'react-bootstrap';
import './styles.css';
import { generateUUID, numberFormatCurrency } from '../../../utils/helper';
import moment from 'moment';

const DataTableSkeleton = () => {
  return (
    <table className="table-bs table">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th className="text-right">
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </th>
          <th className="text-right">
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </th>
          <th className="text-right">
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </th>
          <th className="text-right">
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr className="row-type-group">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right"></td>
          <td className="text-right"></td>
          <td className="text-right"></td>
          <td className="text-right"></td>
        </tr>
        <tr className="row-type-subgroup">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-line_item">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-group">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right"></td>
          <td className="text-right"></td>
          <td className="text-right"></td>
          <td className="text-right"></td>
        </tr>
        <tr className="row-type-subgroup">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-line_item">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-group">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right"></td>
          <td className="text-right"></td>
          <td className="text-right"></td>
          <td className="text-right"></td>
        </tr>
        <tr className="row-type-subgroup">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-line_item">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-accounts">
          <td>
            {' '}
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
        <tr className="row-type-subgroup">
          <td>
            <Skeleton variant="text" width={220} height={25} />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
          <td className="text-right">
            {' '}
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ float: 'right' }}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

const CellFiller = ({ length = 2 }) => {
  const cells = [];

  for (let i = 0; i < length; i++) {
    cells.push(<td key={`${i}_${generateUUID()}`}>&nbsp;</td>);
  }

  return <>{cells.map((r) => r)}</>;
};

const DataLoadedTable = ({ params, data }) => {
  const colSpanFiller = data?.depository_banks
    ? data.depository_banks.length * 2 + 2
    : 2; // account for the empty row

  return (
    <Table className="table-cf mb-0 " hover>
      <thead>
        <tr>
          <th
            colSpan={2}
            rowSpan={2}
            style={{ verticalAlign: 'middle', minWidth: '450px' }}
          >
            PARTICULARS
          </th>
          {data.depository_banks.map((row) => (
            <th colSpan={2} key={`${row.banks_id}_b`} className="text-center">
              {row.bank_shortname}
            </th>
          ))}
        </tr>
        <tr>
          {data.depository_banks.map((row) => (
            <Fragment key={`${row.banks_id}_header`}>
              <th
                className="text-center"
                style={{ backgroundColor: '#b9d5ac' }}
              >
                RECEIPT
              </th>
              <th
                className="text-center"
                style={{ backgroundColor: '#b9d5ac' }}
              >
                DISBURSEMENT
              </th>
            </Fragment>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr className="row-subgroup">
          <td colSpan={2}>CASH, BEG (BANK BAL)</td>

          {data.depository_banks.map((row) => (
            <Fragment key={`${row.banks_id}_beg_bal`}>
              <td className="text-center" colSpan={2}>
                {numberFormatCurrency(data.beg_balance[`${row.banks_id}`])}
              </td>
            </Fragment>
          ))}
        </tr>
        <tr>{<CellFiller length={colSpanFiller} />}</tr>
        <tr className="row-group">
          <td colSpan={2}>CASH PROVIDED/USED BY OPERATING ACTIVITIES</td>
          {<CellFiller length={colSpanFiller - 2} />}
        </tr>

        <tr className="row-subgroup">
          <td colSpan={2}>CASH INFLOWS:</td>
          {<CellFiller length={colSpanFiller - 2} />}
        </tr>

        {data.cash_in_flow.map((row) => (
          <tr key={row.account_code}>
            <td>{row.account_code}</td>
            <td>{row.account_name}</td>
            {data.depository_banks.map((b) => (
              <Fragment key={`${b.banks_id}_cif`}>
                <td className="text-right">
                  {numberFormatCurrency(row[`${b.banks_id}_credit`])}
                </td>
                <td className="text-right">
                  {numberFormatCurrency(row[`${b.banks_id}_debit`])}
                </td>
              </Fragment>
            ))}
          </tr>
        ))}

        <tr className="row-group-total">
          <td colSpan={2}>TOTAL CASH INFLOWS</td>
          {data.depository_banks.map((b) => (
            <Fragment key={`${b.banks_id}_cift`}>
              <td className="text-right">
                {numberFormatCurrency(
                  data.cash_in_flow_total[`${b.banks_id}_credit`],
                )}
              </td>
              <td className="text-right">
                {numberFormatCurrency(
                  data.cash_in_flow_total[`${b.banks_id}_debit`],
                )}
              </td>
            </Fragment>
          ))}
        </tr>

        <tr>{<CellFiller length={colSpanFiller} />}</tr>
        <tr className="row-subgroup">
          <td colSpan={2}>CASH OUTFLOWS</td>
          {<CellFiller length={colSpanFiller - 2} />}
        </tr>
        <tr className="row-subgroup">
          <td colSpan={2}>MD Related Benefits</td>
          {<CellFiller length={colSpanFiller - 2} />}
        </tr>
        {data.md_related.map((row) => (
          <tr key={row.account_code}>
            <td>{row.account_code}</td>
            <td>{row.account_name}</td>
            {data.depository_banks.map((b) => (
              <Fragment key={`${b.banks_id}_mdr`}>
                <td className="text-right">
                  {numberFormatCurrency(row[`${b.banks_id}_credit`])}
                </td>
                <td className="text-right">
                  {numberFormatCurrency(row[`${b.banks_id}_debit`])}
                </td>
              </Fragment>
            ))}
          </tr>
        ))}
        <tr className="row-subgroup top-line">
          <td colSpan={2}>Total MD Related Expenses</td>
          {data.depository_banks.map((b) => (
            <Fragment key={`${b.banks_id}_mdrt`}>
              <td className="text-right">
                {numberFormatCurrency(
                  data.md_related_total[`${b.banks_id}_credit`],
                )}
              </td>
              <td className="text-right">
                {numberFormatCurrency(
                  data.md_related_total[`${b.banks_id}_debit`],
                )}
              </td>
            </Fragment>
          ))}
        </tr>
        <tr>{<CellFiller length={colSpanFiller} />}</tr>
        <tr className="row-subgroup">
          <td colSpan={2}>Non-MD Related Benefits</td>
          {<CellFiller length={colSpanFiller - 2} />}
        </tr>
        {data.not_md_related.map((row) => (
          <tr key={row.account_code}>
            <td>{row.account_code}</td>
            <td>{row.account_name}</td>
            {data.depository_banks.map((b) => (
              <Fragment key={`${b.banks_id}_nmdr`}>
                <td className="text-right">
                  {numberFormatCurrency(row[`${b.banks_id}_credit`])}
                </td>
                <td className="text-right">
                  {numberFormatCurrency(row[`${b.banks_id}_debit`])}
                </td>
              </Fragment>
            ))}
          </tr>
        ))}
        <tr className="row-subgroup top-line">
          <td colSpan={2}>Total Operating Expenses</td>
          {data.depository_banks.map((b) => (
            <Fragment key={`${b.banks_id}_toe`}>
              <td className="text-right">
                {numberFormatCurrency(
                  data.not_md_related_total[`${b.banks_id}_credit`],
                )}
              </td>
              <td className="text-right">
                {numberFormatCurrency(
                  data.not_md_related_total[`${b.banks_id}_debit`],
                )}
              </td>
            </Fragment>
          ))}
        </tr>
        <tr>{<CellFiller length={colSpanFiller} />}</tr>
        <tr className="row-group-total">
          <td colSpan={2}>TOTAL CASH OUTFLOWS</td>
          {data.depository_banks.map((b) => (
            <Fragment key={`${b.banks_id}_tco`}>
              <td className="text-right">
                {numberFormatCurrency(
                  data.cash_out_flow_total[`${b.banks_id}_credit`],
                )}
              </td>
              <td className="text-right">
                {numberFormatCurrency(
                  data.cash_out_flow_total[`${b.banks_id}_debit`],
                )}
              </td>
            </Fragment>
          ))}
        </tr>
        <tr className="row-group">
          <td colSpan={2}>TOTAL CASH PROVIDED/USED BY OPERATING ACTIVITIES</td>
          {data.depository_banks.map((b) => (
            <Fragment key={`${b.banks_id}_tcpoa`}>
              <td className="text-right">
                {numberFormatCurrency(
                  data.operating_activities_total[`${b.banks_id}_credit`],
                )}
              </td>
              <td className="text-right">
                {numberFormatCurrency(
                  data.operating_activities_total[`${b.banks_id}_debit`],
                )}
              </td>
            </Fragment>
          ))}
        </tr>
        <tr>{<CellFiller length={colSpanFiller} />}</tr>
        <tr className="row-group">
          <td colSpan={2}>CASH PROVIDED/USED BY INVESTING ACTIVITIES</td>
          {<CellFiller length={colSpanFiller - 2} />}
        </tr>
        {data.investing_activities.map((row) => (
          <tr key={row.account_code}>
            <td>{row.account_code}</td>
            <td>{row.account_name}</td>
            {data.depository_banks.map((b) => (
              <Fragment key={`${b.banks_id}_ia`}>
                <td className="text-right">
                  {numberFormatCurrency(row[`${b.banks_id}_credit`])}
                </td>
                <td className="text-right">
                  {numberFormatCurrency(row[`${b.banks_id}_debit`])}
                </td>
              </Fragment>
            ))}
          </tr>
        ))}
        <tr className="row-group">
          <td colSpan={2}>TOTAL CASH PROVIDED/USED BY INVESTING ACTIVITIES</td>
          {data.depository_banks.map((b) => (
            <Fragment key={`${b.banks_id}_tia`}>
              <td className="text-right">
                {numberFormatCurrency(
                  data.investing_activities_total[`${b.banks_id}_credit`],
                )}
              </td>
              <td className="text-right">
                {numberFormatCurrency(
                  data.investing_activities_total[`${b.banks_id}_debit`],
                )}
              </td>
            </Fragment>
          ))}
        </tr>
        <tr>{<CellFiller length={colSpanFiller} />}</tr>
        <tr className="row-group">
          <td colSpan={2}>CASH PROVIDED/USED BY FINANCING ACTIVITIES</td>
          {<CellFiller length={colSpanFiller - 2} />}
        </tr>
        {data.financing_activities.map((row) => (
          <tr key={row.account_code}>
            <td>{row.account_code}</td>
            <td>{row.account_name}</td>
            {data.depository_banks.map((b) => (
              <Fragment key={`${b.banks_id}_fa`}>
                <td className="text-right">
                  {numberFormatCurrency(row[`${b.banks_id}_credit`])}
                </td>
                <td className="text-right">
                  {numberFormatCurrency(row[`${b.banks_id}_debit`])}
                </td>
              </Fragment>
            ))}
          </tr>
        ))}
        <tr className="row-group">
          <td colSpan={2}>TOTAL CASH PROVIDED/USED BY FINANCING ACTIVITIES</td>
          {data.depository_banks.map((b) => (
            <Fragment key={`${b.banks_id}_tfa`}>
              <td className="text-right">
                {numberFormatCurrency(
                  data.financing_activities_total[`${b.banks_id}_credit`],
                )}
              </td>
              <td className="text-right">
                {numberFormatCurrency(
                  data.financing_activities_total[`${b.banks_id}_debit`],
                )}
              </td>
            </Fragment>
          ))}
        </tr>
        <tr>{<CellFiller length={colSpanFiller} />}</tr>
        <tr className="row-total-group">
          <td colSpan={2}>NET CASHFLOW</td>
          {data.depository_banks.map((b) => (
            <Fragment key={`${b.banks_id}_nc`}>
              <td className="text-right">
                {numberFormatCurrency(
                  data.net_cash_flow[`${b.banks_id}_credit`],
                )}
              </td>
              <td className="text-right">
                {numberFormatCurrency(
                  data.net_cash_flow[`${b.banks_id}_debit`],
                )}
              </td>
            </Fragment>
          ))}
        </tr>
        <tr>{<CellFiller length={colSpanFiller} />}</tr>
        <tr className="row-total-group">
          <td colSpan={2}>ENDING BOOK BALANCES</td>
          {data.depository_banks.map((b) => (
            <Fragment key={`${b.banks_id}_nc`}>
              <td className="text-center" colSpan={2}>
                {numberFormatCurrency(
                  data.ending_book_balance[`${b.banks_id}`],
                )}
              </td>
            </Fragment>
          ))}
        </tr>
      </tbody>
    </Table>
  );
};

const DataTable = ({ isLoading, params, data }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        border: '1px solid #f1f1f1',
        width: '100%',
        // maxWidth: '1200px',
        margin: '0 auto 20px',
      }}
    >
      <Box
        p={2}
        sx={{
          marin: '0 auto',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          textAlign: 'center',
        }}
      >
        <div>
          <div>
            {isLoading ? (
              <Skeleton
                variant="text"
                width={220}
                height={25}
                sx={{ margin: '0 auto' }}
              />
            ) : (
              `Bell-Kenz Pharma Inc.`
            )}
          </div>
          <div>
            {isLoading ? (
              <Skeleton
                variant="text"
                width={250}
                height={25}
                sx={{ margin: '0 auto' }}
              />
            ) : (
              `Statement Of Cash Flow`
            )}
          </div>
          <div>
            {isLoading ? (
              <Skeleton
                variant="text"
                width={230}
                height={25}
                sx={{ margin: '0 auto' }}
              />
            ) : params?.date_from === params?.date_to ? (
              `As of ${moment(params.date_from).format('MMM DD, YYYY')}`
            ) : (
              `${moment(params.date_from).format('MMM DD, YYYY')} - ${moment(
                params.date_to,
              ).format('MMM DD, YYYY')}`
            )}
          </div>
        </div>
      </Box>

      <Box sx={{ overflowX: 'auto', minHeight: '800px' }}>
        {isLoading || !data ? (
          <DataTableSkeleton />
        ) : (
          <DataLoadedTable data={data} params={params} />
        )}
      </Box>
    </Box>
  );
};

export default DataTable;
